import { Hotel } from '@/types';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import { useParams, Link } from 'react-router-dom';

type WelcomeBannerProps = {
  hotel: Hotel;
};

export function WelcomeBanner({ hotel }: WelcomeBannerProps) {
  const { t } = useLanguage();
  const { hotelId } = useParams<{ hotelId: string }>();

  return (
    <div className="relative rounded-xl overflow-hidden mb-6 animate-fade-in">
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent z-10"></div>
      <img
        src={hotel.featuredImage || 'https://picsum.photos/id/430/800/400'}
        alt={hotel.name}
        className="w-full aspect-[2/1] object-cover"
      />
      <div className="absolute inset-x-0 bottom-0 z-20 p-4 text-white">
        <h1 className="text-2xl font-bold mb-1">
          {t('welcomeMessage')} {hotel.name}
        </h1>
        {hotel.description && (
          <p className="text-sm text-white/90 mb-3 line-clamp-2">
            {hotel.description}
          </p>
        )}
      </div>
    </div>
  );
}